var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business_center",
    filter: "url(#filter0_d_1776_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3332 37.3343V35.001H9.02317L8.99984 44.3343C8.99984 46.9243 11.0765 49.001 13.6665 49.001H46.3332C48.9232 49.001 50.9998 46.9243 50.9998 44.3343V35.001H34.6665V37.3343H25.3332ZM48.6665 16.3343H39.3098V11.6676L34.6432 7.00098H25.3098L20.6432 11.6676V16.3343H11.3332C8.7665 16.3343 6.6665 18.4343 6.6665 21.001V28.001C6.6665 30.591 8.74317 32.6676 11.3332 32.6676H25.3332V28.001H34.6665V32.6676H48.6665C51.2332 32.6676 53.3332 30.5676 53.3332 28.001V21.001C53.3332 18.4343 51.2332 16.3343 48.6665 16.3343ZM34.6665 16.3343H25.3332V11.6676H34.6665V16.3343Z",
    fill: "#9F2FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1776_1878",
    x: -4.30313,
    y: -2.10104,
    width: 77.0104,
    height: 77.0104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.20209,
    dy: 8.40418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1776_1878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1776_1878",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenter);
export default __webpack_public_path__ + "static/media/businessCenter.6a46ab88a0543691c8dfda818f5e9d48.svg";
export { ForwardRef as ReactComponent };